// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/** banner */\n.mu8-banner img {\n  width: 100%;\n  height: auto;\n}\n", "",{"version":3,"sources":["webpack://./src/yinghai/libs/banner/banner.less"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACI,WAAA;EACA,YAAA;AACJ","sourcesContent":["/** banner */\n.mu8-banner img {\n    width: 100%;\n    height: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
